import { useEffect } from 'react';
import { useReactFlow } from '@xyflow/react';
import { SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';

export interface UseNodeDeleteOnKeyPressParams {
  nodeId: string;
  exclusivelySelected: boolean;
  editMode: boolean;
}

/**
 * Hook that deletes a node when the Delete or Backspace key is pressed
 * while the node is exclusively selected and NOT in edit mode.
 */
export const useNodeDeleteOnKeyPress = ({
  nodeId,
  exclusivelySelected,
  editMode,
}: UseNodeDeleteOnKeyPressParams): void => {
  const { setNodes } = useReactFlow<SweepCanvasRfNode>();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Only delete if exclusively selected and NOT in edit mode
      if (!exclusivelySelected || editMode) {
        return;
      }

      // Check for Delete or Backspace key
      if (event.key === 'Delete' || event.key === 'Backspace') {
        event.preventDefault();
        setNodes((nodes) => nodes.filter((node) => node.id !== nodeId));
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [nodeId, exclusivelySelected, editMode, setNodes]);
};
